import { PIXIScrollBox } from './UI/PIXIScrollBox';
import GameObject from 'GameObject/GameObject';
import TransformComponent from 'Component/Transform';
import Renderable from 'Component/Renderable';
import { ScrollBoxComponent } from 'Component/Render/ScrollBox';

export class ScrollBox extends GameObject<PIXIScrollBox> {
    protected instantiateContainer(params: any): void {
        this.container = new PIXIScrollBox({
            ...params,
        });
    }

    protected onCreate(params: {}) {
        this.addComponent<ScrollBoxComponent>(ScrollBoxComponent, {});
        this.addComponent(TransformComponent, params);
        this.addComponent(Renderable, params);
    }

    public resize(scrollWidth: number, scrollHeight: number, boxWidth?: number, boxHeight?: number): void {
        this.container.resize(scrollWidth, scrollHeight, boxWidth, boxHeight);
    }

    public destroy() {
        // Call `removeListeners()` manually when the GameObject is destroyed.
        // TODO: For some reason the `Viewport.destroy()` is not called when the Scrollbox parent is destroyed.
        // Note that this is seemingly unrelated to the `removeListeners()` override in the `Viewport.ts` GameObject prototype file.
        this.container.content.removeListeners();
        super.destroy();
    }
}
